import { DOMNode, Text } from 'html-react-parser';
import { IeltsThemeObject } from '../../hooks/useIeltsTheme';

export const configQuestionContent = (domNode: DOMNode, theme: IeltsThemeObject) => {
  if (domNode.type === 'tag' && domNode.name === 'figure' && domNode.attribs.class === 'table') {
    domNode.attribs = {
      ...domNode.attribs,
      style: 'width: 100%',
    };
  }
  if (domNode.type === 'tag' && domNode.name === 'table') {
    domNode.attribs = {
      ...domNode.attribs,
      style: `border-collapse: collapse; border-spacing: 0; border: 1px solid #75b9fc;`,
      class: 'max-w-full min-w-[60%] table-fixed',
    };
  }

  if (domNode.type === 'tag' && domNode.name === 'th') {
    domNode.attribs = {
      ...domNode.attribs,
      style: `border: 1px solid #75b9fc; background: #D2E4FC;`,
      class: 'p-[0.5rem]',
    };
  }

  if (domNode.type === 'tag' && domNode.name === 'td') {
    domNode.attribs = {
      ...domNode.attribs,
      style: `border: 1px solid #75b9fc;`,
      class: 'p-[0.5rem]',
    };
  }

  if (domNode.type === 'tag' && domNode.name === 'mark') {
    const data = (domNode.children[0] as Text)?.data;
    if (typeof data === 'string' && /^\d+$/.test(data)) {
      return (
        // questionIndexBgColor is #EBEBEB in every theme including CLASSIC_BLACK,
        // so the badge is always a light chip and the inner dark label always
        // reads. The old CLASSIC_BLACK branch forced #000 over that same label.
        <span
          className="w-[26px] h-[26px] max-md:w-[22px] max-md:h-[22px] rounded-full inline-flex justify-center items-center select-none mb-[10px]"
          style={{
            backgroundColor: theme.questionIndexBgColor,
          }}
        >
          <span className="!text-[#383838] text-[13px] max-md:text-[11px] font-bold">{data}</span>
        </span>
      );
    }
  }

  return domNode;
};
